module.exports = __webpack_public_path__ + "static/media/icon_syringe.8ee59557.svg";